import { MeetingPage as MeetingScreen } from '../../features/meetings/MeetingPage'

/** S7 Meeting (case team view). */
export function MeetingPage() {
  return <MeetingScreen area="workspace" />
}
